import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Group, Text } from '@mantine/core';
import { useOs } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import classes from './SpotlightButton.module.css';

type SpotlightButtonPropsType = {
  onClick: () => void;
};

export const SpotlightButton: React.FC<SpotlightButtonPropsType> = ({
  onClick,
}) => {
  const { t } = useTranslation();
  const os = useOs();

  const shortcutLabel = os === 'macos' ? '⌘ + K' : 'Ctrl + K';

  return (
    <Button onClick={onClick} data-testid="spotlight-button" className={classes.spotlightButton}>
      <Group align="center" justify="flex-start" wrap="nowrap">
        <FontAwesomeIcon icon={faSearch} size="lg" />
        <Text variant="dimmed">{t('HEADER.SPOTLIGHT_SEARCH.PLACEHOLDER')}</Text>
        <Text visibleFrom="sm" className={classes.spotlightButtonShortcut}>
          {shortcutLabel}
        </Text>
      </Group>
    </Button>
  );
};
